import { Button } from "@/modern/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/modern/components/ui/dropdown-menu";
import { ArrowUpDown, ArrowUpAZ, Calendar, FileType, HardDrive } from "lucide-react";
import { useMyMediaContext, SortOption } from "../context/MyMediaContext";

const sortOptions: { value: SortOption; label: string; icon: React.ReactNode }[] = [
  { value: "name", label: "Name", icon: <ArrowUpAZ className="h-4 w-4" /> },
  { value: "type", label: "Type", icon: <FileType className="h-4 w-4" /> },
  { value: "date", label: "Date", icon: <Calendar className="h-4 w-4" /> },
  { value: "size", label: "Size", icon: <HardDrive className="h-4 w-4" /> },
];

export const SortDropdown = () => {
  const { sortOption, setSortOption } = useMyMediaContext();
  const currentOption = sortOptions.find((opt) => opt.value === sortOption);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          {currentOption?.icon}
          <span>{currentOption?.label || "Sort"}</span>
          <ArrowUpDown className="h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {sortOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => setSortOption(option.value)}
            className={sortOption === option.value ? "bg-accent" : ""}
          >
            <span>{option.icon}</span>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
